<!-- <div class="container" style="height: 100vh;">
    <div class="row align-items-center h-100">
        <div class="col-6 mx-auto">
            
            <p-progressSpinner></p-progressSpinner>
                
                <h3 style="text-align: center;margin: 5%;">Logging you out</h3>
            
        </div>
       
    </div> -->

<!-- </div> -->
<div class="exception-body">
    <div class="exception-topbar">
        <a href="javascript:void(0)" (click)="openLink('HOMPAGE_BASE_URL','','_self');" class="logo">
            <img [src]="this.logo_url" alt="eglobaldoctors" />
        </a>
    </div>


    <div class="container top-bottom-space">
        <div class="ui-lg-6">
            <div class="exception-panel" style="padding-top: 10%;">
                <h1 class="exception-summary">Logging you out </h1>
                <div class="exception-detail">
                    <h4>You will be redirected to the home page</h4>
                    <p-progressSpinner [style]="{ width:'25%', height:'25%'}" animationDuration=0s></p-progressSpinner>

                </div>

                <div>
                    <button type="button" pButton label="Go To Home" [routerLink]="['/', this.slug]"></button>
                </div>
            </div>
        </div>
    </div>
</div>



<app-home-footer></app-home-footer>